import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useParams } from 'react-router-dom';
import { Badge, Layout, Typography } from 'antd';
import { CalendarOutlined, CloudSyncOutlined, HomeOutlined, MessageOutlined, UserOutlined } from '@ant-design/icons';
import { outboxCount, outboxSubscribe } from '@velora/sync';

/**
 * Teacher surface shell — mobile-first tab bar layout. Nests inside ProductShell.
 * Two tabs today: Today (register + marks) and Profile (weekly schedule).
 */
export function TeacherShell() {
  const { institution = '' } = useParams<{ institution: string }>();
  const [queued, setQueued] = useState<number>(outboxCount());
  useEffect(() => outboxSubscribe(() => setQueued(outboxCount())), []);
  return (
    <Layout style={{ minHeight: 'calc(100vh - 50px)', background: '#f7f7f5' }}>
      <Layout.Content style={{ padding: '18px 18px 74px', maxWidth: 720, margin: '0 auto', width: '100%' }}>
        <div style={{ marginBottom: 12, display: 'flex', alignItems: 'baseline', gap: 8 }}>
          <Typography.Text type="secondary" style={{ fontSize: 11, letterSpacing: 0.4, textTransform: 'uppercase', fontWeight: 600 }}>
            Teacher
          </Typography.Text>
          <div style={{ flex: 1 }} />
          {queued > 0 && (
            <Link to={`/i/${institution}/teacher/offline`} style={{ fontSize: 11, color: '#a24040' }}>
              <CloudSyncOutlined /> {queued} queued
            </Link>
          )}
        </div>
        <Outlet />
      </Layout.Content>

      <nav
        style={{
          position: 'fixed', bottom: 0, left: 0, right: 0,
          display: 'flex', justifyContent: 'space-around',
          background: '#fff', borderTop: '1px solid #e6e6e9',
          padding: '8px 0', zIndex: 100,
        }}
      >
        <TabItem to={`/i/${institution}/teacher`} end icon={<HomeOutlined />} label="Today" />
        <TabItem to={`/i/${institution}/teacher/messages`} icon={<MessageOutlined />} label="Messages" />
        <TabItem to={`/i/${institution}/teacher/leaves`} icon={<CalendarOutlined />} label="Leaves" />
        <TabItem to={`/i/${institution}/teacher/profile`} icon={<UserOutlined />} label="Profile" />
        <TabItem to={`/i/${institution}/teacher/offline`} icon={<Badge count={queued} size="small" offset={[2, -2]}><CloudSyncOutlined style={{ color: queued > 0 ? '#a24040' : undefined }} /></Badge>} label="Sync" />
      </nav>
    </Layout>
  );
}

function TabItem({ to, icon, label, end }: { to: string; icon: React.ReactNode; label: string; end?: boolean }) {
  return (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 2, textDecoration: 'none',
        color: isActive ? '#2f6ab0' : '#5b6478',
        fontSize: 11, fontWeight: isActive ? 600 : 500,
      })}
    >
      <span style={{ fontSize: 20 }}>{icon}</span>
      {label}
    </NavLink>
  );
}
